import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import FeaturesSection from './components/FeaturesSection';
import RelatedBusinessSection from './components/RelatedBusinessSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="bg-[#0f1115]">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <FeaturesSection />
      <RelatedBusinessSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
